import React from 'react';
import { matchActionItemToTask } from '../utils/fathomSummaryParser';

function StatusDot({ completed }) {
  return (
    <span
      className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 mt-1.5 ${
        completed ? 'bg-green-500' : 'bg-red-500'
      }`}
      title={completed ? 'Completed' : 'Not completed'}
    />
  );
}

export default function MeetingSummaryActionItems({ actionItems = [], tasks = [] }) {
  if (!actionItems.length) {
    return (
      <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 text-center text-sm text-gray-500 dark:text-gray-400">
        No action items for this meeting.
      </div>
    );
  }

  return (
    <ul className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 space-y-3">
      {actionItems.map((item, index) => {
        const description =
          typeof item === 'string' ? item : item?.description || item?.text || '';
        if (!description.trim()) return null;

        const matchedTask = matchActionItemToTask(item, tasks);
        const completed = matchedTask
          ? matchedTask.completed === true
          : !!(typeof item === 'object' && item?.completed);

        const assigneeName =
          typeof item === 'object' ? item?.assigneeName || item?.assigneeEmail : null;

        return (
          <li key={index} className="flex items-start gap-3 text-sm">
            <StatusDot completed={completed} />
            <div className="flex-1 min-w-0">
              <p className="text-gray-900 dark:text-white leading-relaxed">{description.trim()}</p>
              {assigneeName && (
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{assigneeName}</p>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
